import store from '@/store';
import {
  post
} from "@/apis/http";

const TokenKey = 'accessToken'
export function getToken(token) {
  return localStorage.getItem(token || TokenKey)
}
export function setToken(TokenKey, token) {
  return localStorage.setItem(TokenKey, token)
}
export function removeToken(name) {
  return localStorage.removeItem(name)
}

//判断当前用户是否有权限登录租户
export async function authorization() {
  const params = {};
  const {
    success,
    result
  } = await post(`${store.state.config.SGKT_URL}/basedata/auth/authorization`, params);
  if (success) {
    return result;
  }
}

//刷新token
export async function refreshToken() {
  const ms_username = getToken('ms_username');
  const userInfo = JSON.parse(ms_username);
  const params = {
    refreshToken: userInfo.refreshToken,
    userId: userInfo.userId
  };
  const {
    success,
    result
  } = await post(`${store.state.config.SGKT_URL}/basedata/auth/refreshToken`, params);
  if (success) {
    setToken("accessToken", result.accessToken);
    setToken("idToken", result.idToken);
    setToken("ms_username", JSON.stringify(Object.assign(userInfo, result)));
    location.reload();
  }
}

/**
 * 登录
 * @param
 */
export function login() {
  clearStorage();
  let {
    pathname,
    origin
  } = window.location;
  let query = getQueryObject();

  if (pathname.charAt(pathname.length - 1) !== '/') pathname += '/';
  if (query.state) delete query.state;
  if (query.code) delete query.code;

  Object.keys(query).map((item, index) => {
    if (index == 0) {
      pathname += `?${item}=${query[item]}`
    } else {
      pathname += `&${item}=${query[item]}`
    }
  })



  //老平台
  let urlOld = `${store.state.config.OPEN_API_URL}/authApi/auth/authorize?client_id=${store.state.config.BASE_CLIENT_ID}&response_type=code&redirect_uri=${origin}${encodeURIComponent(pathname)}`;
  // 新平台
  let urlNew = `${store.state.config.OPEN_API_URL}/oauth2/v1/connect/authorize?grant_type=authorization_code&response_type=code&client_id=${store.state.config.BASE_CLIENT_ID}&state=${Math.random()}&redirect_uri=${origin}${encodeURIComponent(pathname)}`;

  console.log("登录登录")
  console.log(store.state.config)
  console.log(store.state.config.isNewflat)
  console.log((store.state.config.isNewflat == 'true' || store.state.config.isNewflat == true))
  debugger
  window.location.href = (store.state.config.isNewflat == 'true' || store.state.config.isNewflat == true) ? urlNew : urlOld;

}

/**
 * 退出登录
 * @param
 */
export async function quit(path = null) {
  //益阳是老的基础平台
  let {
    origin
  } = window.location;
  if (path && typeof (path) === 'String') {
    //老平台
    let urlOld = `${store.state.config.OPEN_API_URL}/authApi/auth/logout?redirect_uri=${origin}${encodeURIComponent(path)}`;
    // 新平台
    let urlNew = `${store.state.config.OPEN_API_URL}/oauth2/v1/connect/endsession?id_token_hint=${idToken}&post_logout_redirect_uri=${origin}${encodeURIComponent(path)}`;

    window.location.href = (store.state.config.isNewflat == 'true' || store.state.config.isNewflat == true) ? urlNew : urlOld;
    return;
  }

  const quitPathname = store.state.config.quitPath;

  clearStorage();


  //老平台
  let oldURL = `${store.state.config.OPEN_API_URL}/authApi/auth/logout?redirect_uri=${quitPathname}`;
  //新平台
  let newURL = `${store.state.config.OPEN_API_URL}/oauth2/v1/connect/endsession?id_token_hint=${getToken("idToken")}&post_logout_redirect_uri=${encodeURIComponent(quitPathname)}`;
  window.location.href = (store.state.config.isNewflat == 'true' || store.state.config.isNewflat == true) ? newURL : oldURL;
}

// 清空缓存
export function clearStorage() {
  localStorage.removeItem('ms_username')
  localStorage.removeItem("accessToken")
  localStorage.removeItem("idToken")
  localStorage.removeItem('actId')
  localStorage.removeItem('recCode')
}

//获取url参数
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  if (!time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * 导出公共方法 
 * xdf
 */
export function exportFiles(res, name) {
  const fileName = `${name}.xlsx`
  const blob = new Blob(
    [res], {
      type: 'application/vnd.ms-excel'
    }
  );
  const url = window.URL.createObjectURL(blob) //把字节流转为在线预览地址
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}`)
    document.body.appendChild(link);
    link.click()
    // 释放内存
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }
}

//导入成功弹窗
export function msgbox(that) {
  const h = that.$createElement;
  that.$msgbox({
    title: '导入完成',
    message: h('div', null, [
      h('p', null, [
        h('span', null, '可点击'),
        h('span', {
          style: 'color: #409EFF'
        }, '“查看日志”'),
        h('span', null, '查看导入详情')
      ])
    ]),
    showClose: false,
    showCancelButton: true,
    confirmButtonText: '查看日志',
    cancelButtonText: '取消',
  }).then(() => {
    that.$router.push({
      path: '/admin/systemMsg/import-log',
      query: {
        pageName: 'ability-compet'
      }
    })
  }).catch(() => {})
}



// WEBPACK FOOTER //
// ./src/utils/index.js